import provincialModel from 'data/provincial_plan_sidebar.json';
import provincialLegend from 'data/provincial-legend.json';
import { getHandlerFor } from 'client/utils/angular';

export default function ($scope, $window, $rootScope, sidebarService) {
  $scope.provincialSidebar = Object.assign({}, provincialModel);
  $scope.provincialLegend = provincialLegend;

  const update = ({ greenbeltdesign: greenBeltDesign, greenbelttown: greenBeltTown, greenbeltcrop: greenBeltCrop,
                    greenbeltrivervalley: greenbeltRiverValley, ormlanduse: ormLandUse, growthplan: growthPlan, growthplanugc: growthplan_ugc_data,
                    lakesimcoe: lakeSimcoe }) => {

    if (greenBeltDesign || greenBeltTown || greenBeltCrop || greenbeltRiverValley || ormLandUse || growthPlan || growthplan_ugc_data || lakeSimcoe) {
      //Check if there is Greenbelt Designation information
      if ('no_result' in greenBeltDesign) {
        $scope.provincialSidebar.gb_designation[0].error = greenBeltDesign.no_result;
        $scope.policyOn = false;
        $scope.provincialSidebar.gb_designation[0].value = "No";
        $scope.provincialSidebar.gb_designation[1] = [];
      } else if ('error' in greenBeltDesign) {
        $scope.policyOn = false;

        //Set error message for user
        $scope.provincialSidebar.gb_designation[0].error = greenBeltDesign.error;

      } else {
        //Show policy information
        $scope.policyOn = true;

        //Set Greenbelt Plan info
        $scope.provincialSidebar.gb_designation[0].value = "Yes";

        //Set Design info
        $scope.provincialSidebar.gb_designation[1] = greenBeltDesign;

      }

      //Check if there is Greenbelt Town information
      if ('no_result' in greenBeltTown) {
        //There is no town
        $scope.townOn = false;

        $scope.provincialSidebar.gb_town[0].error = "No";

        $scope.provincialSidebar.gb_town[1] = [];
      } else if ('error' in greenBeltTown) {
        //There is no town
        $scope.townOn = false;

        //Set error message for user
        $scope.provincialSidebar.gb_town[0].error = greenBeltTown.error;
      } else {

        //There is town
        $scope.townOn = true;

        //Set the Greenbelt Town info
        $scope.provincialSidebar.gb_town[1] = greenBeltTown;

      }

      //Check if there is Greenbelt Crop information
      if ('no_result' in greenBeltCrop) {
        //There is no crop
        $scope.cropOn = false;

        $scope.provincialSidebar.gb_crop[0].error = "No";

        $scope.provincialSidebar.gb_crop[1] = [];
      } else if ('error' in greenBeltCrop) {
        //There is no crop
        $scope.cropOn = false;

        $scope.provincialSidebar.gb_crop[0].error = greenBeltCrop.error;
      } else {
        //There is crop
        $scope.cropOn = true;

        //Set the Greenbelt Crop info
        $scope.provincialSidebar.gb_crop[1] = greenBeltCrop;
      }

      //Check if there is Greenbelt River Valley information
      if ('no_result' in greenbeltRiverValley) {
        //There is no rivervalley
        $scope.rivervalleyOn = false;

        $scope.provincialSidebar.gb_rivervalley[0].error = "No";
        $scope.provincialSidebar.gb_rivervalley[0].value = "No";
        $scope.provincialSidebar.gb_rivervalley[1] = [];
      } else if ('error' in greenbeltRiverValley) {
        //There is no rivervalley
        $scope.rivervalleyOn = false;

        $scope.provincialSidebar.gb_rivervalley[0].error = greenbeltRiverValley.error;
      } else {
        //There is rivervalley
        $scope.rivervalleyOn = true;

        //Set the Greenbelt River Valley info
        $scope.provincialSidebar.gb_rivervalley[1] = greenbeltRiverValley;
        $scope.provincialSidebar.gb_rivervalley[0].value = "Yes";
      }

      //Check if there is ORM information
      if ('no_result' in ormLandUse) {
        $scope.provincialSidebar.orm[0].error = ormLandUse.no_result;
        $scope.provincialSidebar.orm[1] = [];
        $scope.ormOn = false;
      } else if ('error' in ormLandUse) {
        $scope.ormOn = false;

        //Set error message for user
        $scope.provincialSidebar.orm[0].error = ormLandUse.error;
      } else {
        //Show policy information
        $scope.ormOn = true;

        //Set Greenbelt Plan info
        $scope.provincialSidebar.orm[1] = ormLandUse;

      }

      //Check if there is Growth Plan Information
      if ('no_result' in growthPlan) {
        //There is no growth plan
        $scope.growthOn = false;
        $scope.provincialSidebar.growthplan[0].error = growthPlan.no_result;
        $scope.provincialSidebar.growthplan[1] = [];
      } else if ('error' in growthPlan) {
        //There is no growth plan
        $scope.growthOn = false;

        //Set error message for user
        $scope.provincialSidebar.growthplan[0].error = growthPlan.error;
      } else {
        //There is growth plan
        $scope.growthOn = true;
        //Set the Growth Plan info
        $scope.provincialSidebar.growthplan[1] = growthPlan;
      }

      //Check if there is Growth Plan Urban Growth Centres Information
      if ('no_result' in growthplan_ugc_data) {
        //There is no ugc
        $scope.growthplanugcOn = false;
        $scope.provincialSidebar.growthplan_ugc[0].error = growthplan_ugc_data.no_result;
        $scope.provincialSidebar.growthplan_ugc[1] = [];
      } else if ('error' in growthplan_ugc_data) {
        //There is no ugc
        $scope.growthplanugcOn = false;

        //Set error message for user
        $scope.provincialSidebar.growthplan_ugc[0].error = growthplan_ugc_data.error;
      } else {
        //There is ugc
        $scope.growthplanugcOn = true;
        //Set the Growth Plan info
        $scope.provincialSidebar.growthplan_ugc[1] = growthplan_ugc_data;
      }

      //Check if there is lake simcoe plan information
      if ('no_result' in lakeSimcoe) {

        $scope.provincialSidebar.lakesimcoe[0].error = lakeSimcoe.no_result;
        $scope.provincialSidebar.lakesimcoe[1] = [];
      } else if ('error' in lakeSimcoe) {
        //Set error message for user
        $scope.provincialSidebar.lakesimcoe[0].error = lakeSimcoe.error;
      } else {

        //Set Lake simcoe info
        $scope.provincialSidebar.lakesimcoe[1] = lakeSimcoe;
      }
    }
  };

  if ($scope.legendTitle != "pp")
    $rootScope.$broadcast('map/setlegend', [provincialLegend, "pp"]);

  if (!$scope.isSearchBar) {
    //reset greenbelt on/off button if needed.
    $scope.provincialSidebar.greenbelt[0].toggle = $scope.checkLayer($scope.provincialSidebar.greenbelt[0].name);

    //reset greenbelt on/off button if needed.
    $scope.provincialSidebar.gb_designation[0].toggle = $scope.checkLayer($scope.provincialSidebar.gb_designation[0].name);

    //reset orm on/off button if needed.
    $scope.provincialSidebar.orm[0].toggle = $scope.checkLayer($scope.provincialSidebar.orm[0].name);

    //reset growthplan on/off button if needed.
    $scope.provincialSidebar.growthplan[0].toggle = $scope.checkLayer($scope.provincialSidebar.growthplan[0].name);

    //reset growthplan_ugc on/off button if needed.
    $scope.provincialSidebar.growthplan_ugc[0].toggle = $scope.checkLayer($scope.provincialSidebar.growthplan_ugc[0].name);

    //reset lakesimcoe on/off button if needed.
    $scope.provincialSidebar.lakesimcoe[0].toggle = $scope.checkLayer($scope.provincialSidebar.lakesimcoe[0].name);

    if (!$scope.onSidebar) {
      sidebarService.sidebarInfo({
        type: "provincial_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
    }
  }

  //Turn off the dev app if it's turned on
  if ($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  $scope.policyLink = function (url) {
    $window.open(url, '_blank');
  };

  $scope.policyOn = false;
  $scope.ormOn = false;
  $scope.growthOn = false;
  $scope.townOn = false;
  $scope.cropOn = false;
  $scope.rivervalleyOn = false;

  const toggle = (status) => {
    $scope.provincialSidebar.greenbelt[0].toggle = status;
    $scope.provincialSidebar.orm[0].toggle = status;
    $scope.provincialSidebar.growthplan[0].toggle = status;
    $scope.provincialSidebar.lakesimcoe[0].toggle = status;
  };

  const reset = () => {
    $scope.policyOn = false;
    $scope.ormOn = false;
    $scope.growthOn = false;
    $scope.townOn = false;
    $scope.cropOn = false;
    $scope.rivervalleyOn = false;
    $scope.provincialSidebar = Object.assign({}, provincialModel);
  };

  $rootScope.$on('sidebar/provincial/update', getHandlerFor(update));
  $rootScope.$on('sidebar/provincial/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/provincial/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/provincial_plan_sidebar.js